// eslint-disable-next-line unicorn/prevent-abbreviations
const iconSourceDirective = /* @ngInject */ (
	/** @type {import('angular').IQService} */ $q,
) => ({
	restrict: 'A',
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {import('angular').IAttributes} attributes
	 */
	link(scope, element, attributes) {
		attributes.$observe('ngSrc', ngSource => {
			const deferred = $q.defer(); const
				image = new Image();

			image.addEventListener('error', () => {
				if (ngSource) {
					deferred.resolve(false);
					element.attr('src', '/images/icons/unknown.png');
				}
			});
			image.addEventListener('load', () => {
				deferred.resolve(true);
			});
			image.src = ngSource || '/images/icons/unknown.png';

			return deferred.promise;
		});
	},
});

export default iconSourceDirective;
